import InnerHeader from "./InnerHeader"
import MainMenu from './MainMenu';
import Paper from '@mui/material/Paper';

function Links(){
    return(
        <div>
            <InnerHeader />

            <Paper elevation={2} style={{padding:"10px", marginTop:"10px"}}>
                <h1 style={{textAlign:"center"}}>Links</h1>
                <p>
                <ul>
                    <li>My Coding Lab - <a href="https://codinglab.huostravelblog.com" target="_blank">https://codinglab.huostravelblog.com</a></li>
                    
                    <br />
                    <li>My Travel Blog - <a href="https://www.huostravelblog.com" target="_blank">https://www.huostravelblog.com</a></li>
                    
                    <br />
                    <li>My Teaching Webpage - <a href="https://sites.google.com/site/hchenmath" target="_blank">https://sites.google.com/site/hchenmath</a></li>

                    <br />
                    <li>Linkedin - <a href="https://www.linkedin.com/in/huochen/" target="_blank">https://www.linkedin.com/in/huochen/</a></li>
                </ul>
                </p>
            </Paper>
            <MainMenu shareLink="https://huoatwork.github.io/#/links" />
        </div>
    )
     
}

export default Links